import { Routes, Route, Navigate } from "react-router-dom";
import AppShell from "@/components/layout/AppShell";
import Dashboard from "@/pages/Dashboard";
import Properties from "@/pages/Properties";
import Audits from "@/pages/Audits";
import Findings from "@/pages/Findings";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import Login from "@/pages/Login";
import CrawlList from "@/pages/CrawlList";
import CrawlDetail from "@/pages/CrawlDetail";
import Inspector from "@/pages/Inspector";
import Capabilities from "@/pages/Capabilities";
import PropertyOverview from "@/pages/PropertyOverview";
import PropertyAhrefs from "@/pages/PropertyAhrefs";
import PropertyDataForSEO from "@/pages/PropertyDataForSEO";
import PropertyGSC from "@/pages/PropertyGSC";
import PropertyGA4 from "@/pages/PropertyGA4";
import PropertyServerLogs from "@/pages/PropertyServerLogs";
import PropertyInsights from "@/pages/PropertyInsights";
import PropertyPages from "@/pages/PropertyPages";
import PropertyKeywords from "@/pages/PropertyKeywords";
import PropertyBacklinks from "@/pages/PropertyBacklinks";
import PropertyReviews from "@/pages/PropertyReviews";
import PropertyReports from "@/pages/PropertyReports";
import PropertySettings from "@/pages/PropertySettings";
import PropertyCWV from "@/pages/PropertyCWV";
import { AuthProvider, ProtectedRoute } from "@/lib/auth";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index             element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard"   element={<Dashboard />} />
          <Route path="properties"  element={<Properties />} />

          {/* Per-property workspace — pick a property in the header
              switcher, then browse its data layers via the left rail. */}
          <Route path="p/:propertyId" element={<Navigate to="overview" replace />} />
          <Route path="p/:propertyId/overview" element={<PropertyOverview />} />
          <Route path="p/:propertyId/crawl" element={<CrawlList />} />
          <Route path="p/:propertyId/crawl/:crawlId" element={<CrawlDetail />} />
          <Route path="p/:propertyId/ahrefs" element={<PropertyAhrefs />} />
          <Route path="p/:propertyId/dataforseo" element={<PropertyDataForSEO />} />
          <Route path="p/:propertyId/gsc"         element={<PropertyGSC />} />
          <Route path="p/:propertyId/ga4"         element={<PropertyGA4 />} />
          <Route path="p/:propertyId/server-logs" element={<PropertyServerLogs />} />
          <Route path="p/:propertyId/insights"    element={<PropertyInsights />} />
          <Route path="p/:propertyId/pages"       element={<PropertyPages />} />
          <Route path="p/:propertyId/keywords"    element={<PropertyKeywords />} />
          <Route path="p/:propertyId/backlinks"   element={<PropertyBacklinks />} />
          <Route path="p/:propertyId/reviews"     element={<PropertyReviews />} />
          <Route path="p/:propertyId/cwv"         element={<PropertyCWV />} />
          <Route path="p/:propertyId/audits"      element={<PropertyOverview />} />
          <Route path="p/:propertyId/reports"     element={<PropertyReports />} />
          <Route path="p/:propertyId/settings"    element={<PropertySettings />} />

          {/* Legacy crawl routes — kept for any deep-link bookmarks but
              the new canonical path is /p/:propertyId/crawl. */}
          <Route path="properties/:propertyId/crawls" element={<CrawlList />} />
          <Route path="crawls/:crawlId" element={<CrawlDetail />} />

          <Route path="audits"      element={<Audits />} />
          <Route path="findings"    element={<Findings />} />
          <Route path="reports"     element={<Reports />} />
          <Route path="inspector"   element={<Inspector />} />
          <Route path="capabilities" element={<Capabilities />} />
          <Route path="settings"    element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </AuthProvider>
  );
}
